// TS 5.7+'s stricter ArrayBufferLike types make Uint8Array not directly
// assignable to BlobPart/BodyInit, even though ours are always backed by a
// plain ArrayBuffer. Centralizes the cast instead of scattering it everywhere.
export function bytesToBlob(bytes: Uint8Array, type = "application/octet-stream"): Blob {
  return new Blob([bytes as Uint8Array<ArrayBuffer>], { type });
}

export function bytesToBodyInit(bytes: Uint8Array): BodyInit {
  return bytes as Uint8Array<ArrayBuffer> as BodyInit;
}

export function bytesToHex(bytes: Uint8Array): string {
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export function hexToBytes(hex: string): Uint8Array {
  const clean = hex.trim();
  if (clean.length === 0 || clean.length % 2 !== 0 || /[^0-9a-fA-F]/.test(clean)) {
    throw new Error("not valid hex");
  }
  const out = new Uint8Array(clean.length / 2);
  for (let i = 0; i < out.length; i++) out[i] = parseInt(clean.slice(i * 2, i * 2 + 2), 16);
  return out;
}
